import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../authenticate/authentication.service';
import { Globals } from '../globals';
import { UtilFunctions } from '../util-functions';
import { MessagingService } from '../messaging.service';
declare function info_noti(msg: any): any;
@Component({
  selector: 'app-buy-now-button-click',
  templateUrl: './buy-now-button-click.component.html',
  styleUrls: ['./buy-now-button-click.component.css']
})
export class BuyNowButtonClickComponent implements OnInit {

  constructor( private messagingService: MessagingService,private route: ActivatedRoute,private global: Globals, private router: Router, private authenticate: AuthenticationService) { }
   message;
  ngOnInit() {
  debugger
    // localStorage.setItem('BuyNowBtnStatus','true');
    // alert("buy now component ")
    UtilFunctions.setLocalStorage('BuyNowBtnStatus','true');
    this.router.navigate(['login']);
    
//     var buyNowButtonClick = UtilFunctions.getLocalStorage('BuyNowBtnStatus');
// console.log("local storgae"+buyNowButtonClick);
//     if (this.authenticate.isUserLoggedIn()) {
//       var user = UtilFunctions.getLocalStorage('LoggedInStatus');  
//       const activeRoute = localStorage.getItem('Active Route');
//       //alert("app Component alert"+ buyNowButtonClick)
//       if (user === '1') {
//         // this.router.navigate(['dashboard']);
       
        
//         if(buyNowButtonClick==='true'){
//           this.global.buyNowButtonClick=true;
//       alert("buton true")
//         }
//         this.router.navigate([activeRoute]);

//         this.global.loginCount = 1;
//       }
    

//     } else {
//       if(buyNowButtonClick==='true'){
//         this.global.buyNowButtonClick=true;
//         alert("button true with login")
//       }
//       this.router.navigate(['login']);
//     }
//     console.log("Buy now button true"+this.global.buyNowButtonClick);

// //notification message
//     const userId = '2222';
//     this.messagingService.requestPermission()
//     this.messagingService.receiveMessage()
//     this.message = this.messagingService.currentMessage
//     if(this.message!=null){
//       var obj = JSON.parse(this.message);
//       info_noti(obj.notification.body);
//     }


  }

}
